import React from "react";
import { startOfDay } from "date-fns";
import { OnboardDueDateCard } from "@aph/ui-lib-humanx";
import DatePicker from "@/components/Picker/Date";

interface BirthDateProps {
  heading: any;
  description: any;
  bgIcon: any;
  ctaText: any;
  ctaClick: (date: Date) => void;
  ctaBelowText: any;
  initialDate?: Date;
}

const initialData = {
  heading: {
    prefixText: (
      <span>
        Congratulations, you did it <strong>Mamma!</strong>
      </span>
    ),
  },
  description: {
    prefixText: (
      <span>
        Share your <strong>little one’s date of birth</strong> for tips and tools at each stage of their development
      </span>
    ),
  },
  ctaText: "Next",
  ctaBelowText: "",
  initialDate: startOfDay(new Date()),
};

const BirthDate: React.FC<BirthDateProps> = (props) => {
  const {
    heading = initialData.heading,
    description = initialData.description,
    bgIcon,
    ctaText = initialData.ctaText,
    ctaClick,
    ctaBelowText = initialData.ctaBelowText,
    initialDate = initialData.initialDate,
  } = props;
  const [date, setDate] = React.useState<Date>();

  const handleSubmit = (): void => {
    if (ctaClick && typeof ctaClick === "function") {
      ctaClick(date);
    }
  };

  return (
    <>
      <OnboardDueDateCard
        titleText={heading}
        subTitleText={description}
        backgroundCard={bgIcon}
        middleSection={<DatePicker fullWidth={false} setDate={setDate} initialDate={initialDate} daysLimit={[394]} />}
        ctaText={ctaText}
        ctaClick={handleSubmit}
        ctaBelowText={ctaBelowText}
      />
    </>
  );
};

export default BirthDate;
